"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { useId, useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { cn } from "../../../utils";
import type { VariantProps, SvgProps } from "../../color-block.types";
function SquareSvg(t0) {
  const $ = _c(174);
  const {
    color,
    animated,
    shapeScale
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== animated || $[1] !== shapeScale) {
    t1 = origin => ({
      scale: animated ? shapeScale : 1,
      transformOrigin: origin
    });
    $[0] = animated;
    $[1] = shapeScale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const style = t1;
  switch (color) {
    case "bright-blue":
      {
        const t2 = `${id}-bright-blue`;
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="white" />;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        let t4;
        if ($[4] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[4] = t2;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        const t5 = `url(#${id}-bright-blue)`;
        let t6;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="#5375CF" />;
          $[6] = t6;
        } else {
          t6 = $[6];
        }
        let t7;
        if ($[7] !== style) {
          t7 = <motion.path d="M656 825.511H220.489V607.728C220.489 487.453 317.998 390 438.216 390C558.435 390 656 487.509 656 607.728V825.511Z" fill="#4668C2" style={style("bottom right")} />;
          $[7] = style;
          $[8] = t7;
        } else {
          t7 = $[8];
        }
        let t8;
        if ($[9] !== style) {
          t8 = <motion.path d="M2.73348 -170L438.245 -170L438.245 47.7836C438.245 168.058 340.735 265.511 220.517 265.511C100.299 265.511 2.73351 168.002 2.7335 47.7836L2.73348 -170Z" fill="#4668C2" style={style("top center")} />;
          $[9] = style;
          $[10] = t8;
        } else {
          t8 = $[10];
        }
        let t9;
        if ($[11] !== t5 || $[12] !== t7 || $[13] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[11] = t5;
          $[12] = t7;
          $[13] = t8;
          $[14] = t9;
        } else {
          t9 = $[14];
        }
        let t10;
        if ($[15] !== t4 || $[16] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 656 656" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[15] = t4;
          $[16] = t9;
          $[17] = t10;
        } else {
          t10 = $[17];
        }
        return t10;
      }
    case "light-green":
      {
        const t2 = `${id}-light-green`;
        let t3;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="white" />;
          $[18] = t3;
        } else {
          t3 = $[18];
        }
        let t4;
        if ($[19] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[19] = t2;
          $[20] = t4;
        } else {
          t4 = $[20];
        }
        const t5 = `url(#${id}-light-green)`;
        let t6;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="#9BD7D2" />;
          $[21] = t6;
        } else {
          t6 = $[21];
        }
        let t7;
        if ($[22] !== style) {
          t7 = <motion.path d="M983.089 2.99991L983.089 659L655.047 659C473.88 659 327.089 512.124 327.089 331.042C327.089 149.96 473.965 2.99993 655.047 2.99992L983.089 2.99991Z" fill="#85CDC7" style={style("center right")} />;
          $[22] = style;
          $[23] = t7;
        } else {
          t7 = $[23];
        }
        let t8;
        if ($[24] !== style) {
          t8 = <motion.path d="M-327.089 658.544L-327.089 3.45554L0.497742 3.45555C181.413 3.45556 328 150.127 328 330.958C328 511.788 181.328 658.544 0.497713 658.544L-327.089 658.544Z" fill="#85CDC7" style={style("center left")} />;
          $[24] = style;
          $[25] = t8;
        } else {
          t8 = $[25];
        }
        let t9;
        if ($[26] !== t5 || $[27] !== t7 || $[28] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[26] = t5;
          $[27] = t7;
          $[28] = t8;
          $[29] = t9;
        } else {
          t9 = $[29];
        }
        let t10;
        if ($[30] !== t4 || $[31] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 656 656" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[30] = t4;
          $[31] = t9;
          $[32] = t10;
        } else {
          t10 = $[32];
        }
        return t10;
      }
    case "turquoise":
      {
        const t2 = `${id}-turquoise`;
        let t3;
        if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="white" />;
          $[33] = t3;
        } else {
          t3 = $[33];
        }
        let t4;
        if ($[34] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[34] = t2;
          $[35] = t4;
        } else {
          t4 = $[35];
        }
        const t5 = `url(#${id}-turquoise)`;
        let t6;
        if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="#00A399" />;
          $[36] = t6;
        } else {
          t6 = $[36];
        }
        let t7;
        if ($[37] !== style) {
          t7 = <motion.path d="M656 983L0 983L0 654.958C0 473.791 146.876 327 327.958 327C509.04 327 656 473.876 656 654.958L656 983Z" fill="#00968C" style={style("bottom center")} />;
          $[37] = style;
          $[38] = t7;
        } else {
          t7 = $[38];
        }
        let t8;
        if ($[39] !== style) {
          t8 = <motion.path d="M0.911068 -327L655.089 -327L655.089 0.131165C655.089 180.794 508.621 327.178 328.042 327.178C147.463 327.178 0.911024 180.71 0.911039 0.131107L0.911068 -327Z" fill="#00968C" style={style("top center")} />;
          $[39] = style;
          $[40] = t8;
        } else {
          t8 = $[40];
        }
        let t9;
        if ($[41] !== t5 || $[42] !== t7 || $[43] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[41] = t5;
          $[42] = t7;
          $[43] = t8;
          $[44] = t9;
        } else {
          t9 = $[44];
        }
        let t10;
        if ($[45] !== t4 || $[46] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 656 656" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[45] = t4;
          $[46] = t9;
          $[47] = t10;
        } else {
          t10 = $[47];
        }
        return t10;
      }
    case "peach":
      {
        const t2 = `${id}-peach`;
        let t3;
        if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="white" />;
          $[48] = t3;
        } else {
          t3 = $[48];
        }
        let t4;
        if ($[49] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[49] = t2;
          $[50] = t4;
        } else {
          t4 = $[50];
        }
        const t5 = `url(#${id}-peach)`;
        let t6;
        if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="#FF946A" />;
          $[51] = t6;
        } else {
          t6 = $[51];
        }
        let t7;
        if ($[52] !== style) {
          t7 = <motion.path d="M184.357 656H2.07869e-05V471.666C-0.0422146 392.316 64.2823 328 143.643 328H328V512.334C328 591.684 263.676 656 184.315 656" fill="#F2875E" style={style("bottom left")} />;
          $[52] = style;
          $[53] = t7;
        } else {
          t7 = $[53];
        }
        let t8;
        if ($[54] !== style) {
          t8 = <motion.path d="M512.357 328H328V143.666C327.958 64.3162 392.282 0 471.643 0H656V184.334C656 263.684 591.676 328 512.315 328" fill="#F2875E" style={style("top right")} />;
          $[54] = style;
          $[55] = t8;
        } else {
          t8 = $[55];
        }
        let t9;
        if ($[56] !== t5 || $[57] !== t7 || $[58] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[56] = t5;
          $[57] = t7;
          $[58] = t8;
          $[59] = t9;
        } else {
          t9 = $[59];
        }
        let t10;
        if ($[60] !== t4 || $[61] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 656 656" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[60] = t4;
          $[61] = t9;
          $[62] = t10;
        } else {
          t10 = $[62];
        }
        return t10;
      }
    case "avocado":
      {
        const t2 = `${id}-avocado`;
        let t3;
        if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="white" />;
          $[63] = t3;
        } else {
          t3 = $[63];
        }
        let t4;
        if ($[64] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[64] = t2;
          $[65] = t4;
        } else {
          t4 = $[65];
        }
        const t5 = `url(#${id}-avocado)`;
        let t6;
        if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="#C6E57D" />;
          $[66] = t6;
        } else {
          t6 = $[66];
        }
        let t7;
        if ($[67] !== style) {
          t7 = <motion.path opacity={0.5} d="M328 -97.4888L-97.4888 328L328 753.489L753.489 328L328 -97.4888Z" fill="#B9D871" style={style("center center")} />;
          $[67] = style;
          $[68] = t7;
        } else {
          t7 = $[68];
        }
        let t8;
        if ($[69] !== t5 || $[70] !== t7) {
          t8 = <g clipPath={t5}>{t6}{t7}</g>;
          $[69] = t5;
          $[70] = t7;
          $[71] = t8;
        } else {
          t8 = $[71];
        }
        let t9;
        if ($[72] !== t4 || $[73] !== t8) {
          t9 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 656 656" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t8}</svg>;
          $[72] = t4;
          $[73] = t8;
          $[74] = t9;
        } else {
          t9 = $[74];
        }
        return t9;
      }
    case "sky-blue":
      {
        const t2 = `${id}-sky-blue`;
        let t3;
        if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="white" />;
          $[75] = t3;
        } else {
          t3 = $[75];
        }
        let t4;
        if ($[76] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[76] = t2;
          $[77] = t4;
        } else {
          t4 = $[77];
        }
        const t5 = `url(#${id}-sky-blue)`;
        let t6;
        if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="#90A8ED" />;
          $[78] = t6;
        } else {
          t6 = $[78];
        }
        let t7;
        if ($[79] !== style) {
          t7 = <motion.path d="M368.715 656H4.15737e-05V287.333C-0.0844292 128.632 128.565 0 287.285 0H656V368.667C656 527.368 527.351 656 368.63 656" fill="#839BE0" style={style("center center")} />;
          $[79] = style;
          $[80] = t7;
        } else {
          t7 = $[80];
        }
        let t8;
        if ($[81] !== t5 || $[82] !== t7) {
          t8 = <g clipPath={t5}>{t6}{t7}</g>;
          $[81] = t5;
          $[82] = t7;
          $[83] = t8;
        } else {
          t8 = $[83];
        }
        let t9;
        if ($[84] !== t4 || $[85] !== t8) {
          t9 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 656 656" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t8}</svg>;
          $[84] = t4;
          $[85] = t8;
          $[86] = t9;
        } else {
          t9 = $[86];
        }
        return t9;
      }
    case "orange":
      {
        const t2 = `${id}-orange`;
        let t3;
        if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="white" />;
          $[87] = t3;
        } else {
          t3 = $[87];
        }
        let t4;
        if ($[88] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[88] = t2;
          $[89] = t4;
        } else {
          t4 = $[89];
        }
        const t5 = `url(#${id}-orange)`;
        let t6;
        if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="#EFAC53" />;
          $[90] = t6;
        } else {
          t6 = $[90];
        }
        let t7;
        if ($[91] !== style) {
          t7 = <motion.path d="M656 773.755C656 778.174 652.418 781.755 648 781.755H228.489C224.071 781.755 220.489 778.174 220.489 773.755V563.972C220.489 443.697 317.998 346.244 438.216 346.244C558.435 346.244 656 443.754 656 563.972V773.755Z" fill="#EDA340" style={style("bottom right")} />;
          $[91] = style;
          $[92] = t7;
        } else {
          t7 = $[92];
        }
        let t8;
        if ($[93] !== style) {
          t8 = <motion.path d="M2.7333 -170.755C2.7333 -175.174 6.31503 -178.755 10.7333 -178.755L430.244 -178.755C434.663 -178.755 438.244 -175.174 438.244 -170.755L438.244 39.0281C438.244 159.303 340.735 256.756 220.517 256.756C100.299 256.756 2.73333 159.246 2.73332 39.0281L2.7333 -170.755Z" fill="#EDA340" style={style("top left")} />;
          $[93] = style;
          $[94] = t8;
        } else {
          t8 = $[94];
        }
        let t9;
        if ($[95] !== t5 || $[96] !== t7 || $[97] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[95] = t5;
          $[96] = t7;
          $[97] = t8;
          $[98] = t9;
        } else {
          t9 = $[98];
        }
        let t10;
        if ($[99] !== t4 || $[100] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 656 656" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[99] = t4;
          $[100] = t9;
          $[101] = t10;
        } else {
          t10 = $[101];
        }
        return t10;
      }
    case "sea":
      {
        const t2 = `${id}-sea`;
        let t3;
        if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="white" />;
          $[102] = t3;
        } else {
          t3 = $[102];
        }
        let t4;
        if ($[103] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[103] = t2;
          $[104] = t4;
        } else {
          t4 = $[104];
        }
        const t5 = `url(#${id}-sea)`;
        let t6;
        if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="#008AAA" />;
          $[105] = t6;
        } else {
          t6 = $[105];
        }
        let t7;
        if ($[106] !== style) {
          t7 = <motion.path d="M983.089 2.99991L983.089 659L655.047 659C473.88 659 327.089 512.124 327.089 331.042C327.089 149.96 473.965 2.99993 655.047 2.99992L983.089 2.99991Z" fill="#1A96B3" style={style("center right")} />;
          $[106] = style;
          $[107] = t7;
        } else {
          t7 = $[107];
        }
        let t8;
        if ($[108] !== style) {
          t8 = <motion.path d="M-327.089 658.544L-327.089 3.45554L0.497742 3.45555C181.413 3.45556 328 150.127 328 330.958C328 511.788 181.328 658.544 0.497713 658.544L-327.089 658.544Z" fill="#1A96B3" style={style("center left")} />;
          $[108] = style;
          $[109] = t8;
        } else {
          t8 = $[109];
        }
        let t9;
        if ($[110] !== t5 || $[111] !== t7 || $[112] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[110] = t5;
          $[111] = t7;
          $[112] = t8;
          $[113] = t9;
        } else {
          t9 = $[113];
        }
        let t10;
        if ($[114] !== t4 || $[115] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 656 656" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[114] = t4;
          $[115] = t9;
          $[116] = t10;
        } else {
          t10 = $[116];
        }
        return t10;
      }
    case "mint":
      {
        const t2 = `${id}-mint`;
        let t3;
        if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="white" />;
          $[117] = t3;
        } else {
          t3 = $[117];
        }
        let t4;
        if ($[118] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[118] = t2;
          $[119] = t4;
        } else {
          t4 = $[119];
        }
        const t5 = `url(#${id}-mint)`;
        let t6;
        if ($[120] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="#68C187" />;
          $[120] = t6;
        } else {
          t6 = $[120];
        }
        let t7;
        if ($[121] !== style) {
          t7 = <motion.path d="M184.357 656H2.07869e-05V471.666C-0.0422146 392.316 64.2823 328 143.643 328H328V512.334C328 591.684 263.676 656 184.315 656" fill="#5BB47A" style={style("bottom left")} />;
          $[121] = style;
          $[122] = t7;
        } else {
          t7 = $[122];
        }
        let t8;
        if ($[123] !== style) {
          t8 = <motion.path d="M512.357 328H328V143.666C327.958 64.3162 392.282 0 471.643 0H656V184.334C656 263.684 591.676 328 512.315 328" fill="#5BB47A" style={style("top right")} />;
          $[123] = style;
          $[124] = t8;
        } else {
          t8 = $[124];
        }
        let t9;
        if ($[125] !== t5 || $[126] !== t7 || $[127] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[125] = t5;
          $[126] = t7;
          $[127] = t8;
          $[128] = t9;
        } else {
          t9 = $[128];
        }
        let t10;
        if ($[129] !== t4 || $[130] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 656 656" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[129] = t4;
          $[130] = t9;
          $[131] = t10;
        } else {
          t10 = $[131];
        }
        return t10;
      }
    case "yellow":
      {
        const t2 = `${id}-yellow`;
        let t3;
        if ($[132] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="white" />;
          $[132] = t3;
        } else {
          t3 = $[132];
        }
        let t4;
        if ($[133] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[133] = t2;
          $[134] = t4;
        } else {
          t4 = $[134];
        }
        const t5 = `url(#${id}-yellow)`;
        let t6;
        if ($[135] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="#FFC627" />;
          $[135] = t6;
        } else {
          t6 = $[135];
        }
        let t7;
        if ($[136] !== style) {
          t7 = <motion.path opacity={0.5} d="M328 -97.4888L-97.4889 328L328 753.489L753.489 328L328 -97.4888Z" fill="#F2B91A" style={style("center center")} />;
          $[136] = style;
          $[137] = t7;
        } else {
          t7 = $[137];
        }
        let t8;
        if ($[138] !== t5 || $[139] !== t7) {
          t8 = <g clipPath={t5}>{t6}{t7}</g>;
          $[138] = t5;
          $[139] = t7;
          $[140] = t8;
        } else {
          t8 = $[140];
        }
        let t9;
        if ($[141] !== t4 || $[142] !== t8) {
          t9 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 656 656" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t8}</svg>;
          $[141] = t4;
          $[142] = t8;
          $[143] = t9;
        } else {
          t9 = $[143];
        }
        return t9;
      }
    case "cobalt":
      {
        const t2 = `${id}-cobalt`;
        let t3;
        if ($[144] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="white" />;
          $[144] = t3;
        } else {
          t3 = $[144];
        }
        let t4;
        if ($[145] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[145] = t2;
          $[146] = t4;
        } else {
          t4 = $[146];
        }
        const t5 = `url(#${id}-cobalt)`;
        let t6;
        if ($[147] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="#3B72FF" />;
          $[147] = t6;
        } else {
          t6 = $[147];
        }
        let t7;
        if ($[148] !== style) {
          t7 = <motion.path d="M983.089 2.99991L983.089 659L655.047 659C473.88 659 327.089 512.124 327.089 331.042C327.089 149.96 473.965 2.99993 655.047 2.99992L983.089 2.99991Z" fill="#2E65F2" style={style("center right")} />;
          $[148] = style;
          $[149] = t7;
        } else {
          t7 = $[149];
        }
        let t8;
        if ($[150] !== style) {
          t8 = <motion.path d="M-327.089 658.544L-327.089 3.45554L0.497742 3.45555C181.413 3.45556 328 150.127 328 330.958C328 511.788 181.328 658.544 0.497713 658.544L-327.089 658.544Z" fill="#2E65F2" style={style("center left")} />;
          $[150] = style;
          $[151] = t8;
        } else {
          t8 = $[151];
        }
        let t9;
        if ($[152] !== t5 || $[153] !== t7 || $[154] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[152] = t5;
          $[153] = t7;
          $[154] = t8;
          $[155] = t9;
        } else {
          t9 = $[155];
        }
        let t10;
        if ($[156] !== t4 || $[157] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 656 656" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[156] = t4;
          $[157] = t9;
          $[158] = t10;
        } else {
          t10 = $[158];
        }
        return t10;
      }
    case "ocean":
      {
        const t2 = `${id}-ocean`;
        let t3;
        if ($[159] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="white" />;
          $[159] = t3;
        } else {
          t3 = $[159];
        }
        let t4;
        if ($[160] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[160] = t2;
          $[161] = t4;
        } else {
          t4 = $[161];
        }
        const t5 = `url(#${id}-ocean)`;
        let t6;
        if ($[162] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <path d="M0 7.99999C0 3.58171 3.58172 0 8 0H648C652.418 0 656 3.58172 656 8V648C656 652.418 652.418 656 648 656H7.99999C3.58171 656 0 652.418 0 648V7.99999Z" fill="#1A3C82" />;
          $[162] = t6;
        } else {
          t6 = $[162];
        }
        let t7;
        if ($[163] !== style) {
          t7 = <motion.path d="M184.357 656H2.07869e-05V471.666C-0.0422146 392.316 64.2823 328 143.643 328H328V512.334C328 591.684 263.676 656 184.315 656" fill="#3254A2" style={style("bottom left")} />;
          $[163] = style;
          $[164] = t7;
        } else {
          t7 = $[164];
        }
        let t8;
        if ($[165] !== style) {
          t8 = <motion.path d="M512.357 328H328V143.666C327.958 64.3162 392.282 0 471.643 0H656V184.334C656 263.684 591.676 328 512.315 328" fill="#3254A2" style={style("top right")} />;
          $[165] = style;
          $[166] = t8;
        } else {
          t8 = $[166];
        }
        let t9;
        if ($[167] !== t5 || $[168] !== t7 || $[169] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[167] = t5;
          $[168] = t7;
          $[169] = t8;
          $[170] = t9;
        } else {
          t9 = $[170];
        }
        let t10;
        if ($[171] !== t4 || $[172] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 656 656" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[171] = t4;
          $[172] = t9;
          $[173] = t10;
        } else {
          t10 = $[173];
        }
        return t10;
      }
    default:
      {
        return null;
      }
  }
}
const SquareColorBlock = React.forwardRef<HTMLDivElement, VariantProps>((t0, ref) => {
  const $ = _c(26);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      color: t1,
      animated: t2,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const color = t1 === undefined ? "bright-blue" : t1;
  const animated = t2 === undefined ? true : t2;
  const containerRef = useRef(null);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      target: containerRef,
      offset: ["start end", "end start"]
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    scrollYProgress
  } = useScroll(t3);
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    t5 = [1, 1.3];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  const shapeScale = useTransform(scrollYProgress, t4, t5);
  let t6;
  if ($[9] !== ref) {
    t6 = node => {
      (containerRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
      if (typeof ref === "function") {
        ref(node);
      } else {
        if (ref) {
          ref.current = node;
        }
      }
    };
    $[9] = ref;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = !children && "aspect-square";
  let t8;
  if ($[11] !== className || $[12] !== t7) {
    t8 = cn("relative overflow-hidden", t7, className);
    $[11] = className;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== animated || $[15] !== color || $[16] !== shapeScale) {
    t9 = <SquareSvg color={color} animated={animated} shapeScale={shapeScale} />;
    $[14] = animated;
    $[15] = color;
    $[16] = shapeScale;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== children) {
    t10 = children && <div className="relative z-10 h-full">{children}</div>;
    $[18] = children;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== props || $[21] !== t10 || $[22] !== t6 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div ref={t6} data-slot="color-block" className={t8} {...props}>{t9}{t10}</div>;
    $[20] = props;
    $[21] = t10;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
});
SquareColorBlock.displayName = "SquareColorBlock";
export { SquareColorBlock };